import React from 'react';
import { toast } from 'sonner';

export const notify = {
  success: (msg, opts) => toast.success(msg, opts),
  error: (msg, opts) => toast.error(msg, opts),
  info: (msg, opts) => toast(msg, opts),
  warning: (msg, opts) => toast.warning(msg, opts),
  loading: (msg, opts) => toast.loading(msg, opts),
  dismiss: (id) => toast.dismiss(id),
};

/**
 * Replacement for window.confirm using sonner.
 * Resolves true when user confirms, false on cancel/dismiss/auto-close.
 */
export function confirmToast({
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  duration = 12000,
} = {}) {
  return new Promise((resolve) => {
    let settled = false;
    const finish = (val) => {
      if (settled) return;
      settled = true;
      resolve(val);
    };

    toast.custom(
      (t) => (
        <ConfirmToastBody
          title={title}
          description={description}
          confirmLabel={confirmLabel}
          cancelLabel={cancelLabel}
          danger={danger}
          onConfirm={() => {
            finish(true);
            toast.dismiss(t);
          }}
          onCancel={() => {
            finish(false);
            toast.dismiss(t);
          }}
        />
      ),
      {
        duration,
        onAutoClose: () => finish(false),
        onDismiss: () => finish(false),
      }
    );
  });
}

function ConfirmToastBody({
  title,
  description,
  confirmLabel,
  cancelLabel,
  danger,
  onConfirm,
  onCancel,
}) {
  return (
    <div className="toast-confirm" role="alertdialog" aria-label={title}>
      <div className="toast-confirm-body">
        <div className="toast-confirm-title">{title}</div>
        {description && <div className="toast-confirm-desc">{description}</div>}
      </div>
      <div className="toast-confirm-actions">
        <button type="button" className="toast-btn" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={`toast-btn toast-btn-primary ${danger ? 'danger' : ''}`}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}
